import { envelopeIcon } from "../../elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `SupportInfoWidget` will display contact info to the customer.
 * Intention is to simplify contact with the proper support.
 *
 * @param {string} title - Optional section title
 * @param {SupportInfo} [supportInfo] - The actual data to display
 */
export default class SupportInfoWidget extends Widget {
	constructor({ title = "", supportInfo } = {}) {
		super(...arguments);

		this._title = title;
		this._supportInfo = supportInfo;
	}

	renderContentOn(html) {
		if (!this._supportInfo) {
			return;
		}
		const email = this._supportInfo.getEmail();
		const phone = this._supportInfo.getPhone();
		const webpage = this._supportInfo.getWebpage();

		if (!email && !phone && !webpage) {
			return;
		}

		html.div(
			{ class: "support-info", "data-test": "support-info" },
			this._renderTitleOn.bind(this),
			this._supportLinkRenderer({
				link: phone,
				icon: "fa fa-phone",
				protocol: "tel:",
			}),
			this._supportLinkRenderer({
				link: email,
				icon: envelopeIcon.getCssClass(),
				protocol: "mailto:",
			}),

			this._supportLinkRenderer({
				link: webpage,
				icon: "fa fa-globe",
			}),
		);
	}

	_supportLinkRenderer({ link, icon, protocol }) {
		return (html) => {
			if (!link) return;
			protocol ||= "";

			html.div(
				html.a(
					{ href: `${protocol}${link}` },
					html.i({ class: icon }),
					" ",
					html.span(link),
				),
			);
		};
	}

	_renderTitleOn(html) {
		if (!this._title) {
			return;
		}
		html.h4(this._title);
	}
}
